import React from 'react';
import { getImageMedia } from '../helpers';

/**
 * Template "speaker-intro" — photo, nom, et les quelques lignes qui disent
 * pourquoi on peut croire ce qui suit.
 *
 * `slide.logo` (optionnel) : chemin PUBLIC d'un logo posé sous le nom. Il ne
 * duplique pas celui du bandeau, il le SOURCE — le bandeau porte une marque
 * pendant quarante minutes sans jamais dire de qui il s'agit, et c'est ici,
 * pendant qu'on parle de son employeur, que la salle fait le lien. Une fois.
 */

const SpeakerIntroSlide = ({ slide, slideKey, currentPointIndex, typingStates }) => {
    return (
        <div key={slideKey} className="h-full p-8 flex items-center overflow-hidden relative">
            <div className="grid grid-cols-[1fr_1.8fr] gap-10 w-full items-center min-h-0">
                {/* Left: Photo + Name */}
                <div className="flex flex-col items-center gap-4 animate-fade-in-up">
                    <div className="relative">
                        <div className="absolute -inset-1 bg-gradient-to-br from-blue-500 via-cyan-400 to-purple-500 rounded-2xl opacity-40 blur-md animate-pulse" />
                        <div className="relative w-56 h-56 rounded-2xl overflow-hidden border-2 border-blue-500/30">
                            {getImageMedia(slide.image)}
                        </div>
                    </div>
                    <div className="text-center">
                        <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent">
                            {slide.title}
                        </h2>
                        <p className="text-lg text-blue-300/60 mt-1 font-mono tracking-wide">
                            {slide.subtitle}
                        </p>
                        {slide.logo && (
                            <img
                                src={slide.logo}
                                alt=""
                                className="h-11 w-auto object-contain mx-auto mt-5 opacity-90 animate-fade-in-up stagger-2"
                            />
                        )}
                    </div>
                </div>

                {/* Right: Career milestones */}
                <div className="space-y-2 min-h-0 overflow-hidden">
                    {slide.points.map((point, i) => (
                        <div
                            key={i}
                            className={`flex items-start gap-3 bg-blue-500/5 p-3 rounded-xl border border-blue-500/10 transition-all ${
                                i < currentPointIndex ? 'opacity-100' :
                                i === currentPointIndex ? 'opacity-100 animate-slide-in' :
                                'opacity-0'
                            }`}
                        >
                            <div className={`w-2.5 h-2.5 mt-1.5 rounded-full flex-shrink-0 ${
                                i <= currentPointIndex ? 'bg-cyan-400 animate-pulse-glow' : 'bg-blue-500/30'
                            }`} />
                            <p className="text-xl text-slate-300 m-0 leading-relaxed font-mono flex-1">
                                {i < currentPointIndex ? point :
                                    i === currentPointIndex ? (
                                        <>
                                            {typingStates[i] || ''}
                                            {typingStates[i] !== point && <span className="typing-cursor"></span>}
                                        </>
                                    ) : ''}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SpeakerIntroSlide;
